import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { GenericError } from '../GenericError';
import { unsetTemplateError } from '../../../states/payees/actions';

import withContent from '../../../containers/withContent';
import copContent from '../Content/cop.content';

const mapDispatchToProps = {
	unsetTemplateError,
};

function CreateTemplateError({
	content: { createTemplateDuplicateError },
	errorDetails,
	onPrimary,
	unsetTemplateError,
}) {
	return (
		<GenericError
			onPrimary={() => {
				onPrimary();
				unsetTemplateError();
			}}
			errorDetails={errorDetails}
			errorMessage={errorDetails.status === 409 ? createTemplateDuplicateError : null}
		/>
	);
}

CreateTemplateError.propTypes = {
	content: PropTypes.shape({
		createTemplateDuplicateError: PropTypes.string,
	}).isRequired,
	errorDetails: PropTypes.shape({
		response: PropTypes.shape({
			coded_exceptions: PropTypes.arrayOf(
				PropTypes.shape({ error_status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
			),
		}),
	}),
	onPrimary: PropTypes.func.isRequired,
	unsetTemplateError: PropTypes.func.isRequired,
};

const withContentWrapper = withContent({ content: copContent });
const CreateTemplateErrorWithCompose = compose(
	withContentWrapper,
	connect(null, mapDispatchToProps)
)(CreateTemplateError);

export { CreateTemplateErrorWithCompose as CreateTemplateError };
